module.exports = __webpack_public_path__ + "img/season-selected.4816267f.svg";